import React, { useState, useEffect } from 'react';

import Utils from "../../utilities/Utils";
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";

import ConfigService from '../../service/ConfigsService';

const configService = new ConfigService(); // Create an instance of ConfigService

const ListarConfig = () => {
    const [config, setConfig] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    useEffect(() => {
        initFilters1();
        initConfig();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const initConfig = () => {
        setLoading1(true);
        configService.listAllConfig(iss).then(data => {
            setConfig(data.data.rows);
            setLoading1(false);
        });
    }

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const irParaCadastro = () => {
        if (roles.postConfig)
            history.push('/configs/cadastrar');
    }

    const abreModalDeletar = (toDelete) => {
        console.log(toDelete);
        setToDelete(toDelete);
        setDeleteDialog(true);
    }

    const handleDeleteConfig = () => {
        if (roles.deleteConfig) {
            setLoading1(true)
            configService.deleteConfig(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Tipo excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initConfig();
            });
        }
    }

    const editar = (toEdit) => {
        if (roles.getConfig)
            history.push('/configs/editar/' + toEdit.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {roles.deleteConfig ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {roles.getConfig ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteConfig} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {roles.postConfig ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Parâmetros</h5>
                    <DataTable value={config} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma config cadastrado.">
                        <Column sortable field="nome" header="Configuração" filter filterPlaceholder="Procurar por configuração" style={{ minWidth: '12rem' }} />
                        <Column sortable field="valor" header="Dado" filter filterPlaceholder="Procurar por dado" style={{ minWidth: '12rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o tipo de config selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarConfig, comparisonFn);
